<div class="mainWrap">

  <div *ngIf="!userData?.is_onboarded?.setu && type === 'full'" class="payBillPitchWrap">
    <div class="content" (click)="payBill()">
      <div class="rings">
        <div class="billOptions"></div>
        <div class="billPay"></div>
      </div>
      <div class="desc">
        <div class="title"><div>You Pay a Bill,</div><div>Ketto Contributes.</div></div>
        <div class="subTitle">Every bill you pay triggers a contribution to someone in need</div>
        <div class="note">*0% additional charges</div>
      </div>
      <div class="actBtn">
        <button mat-raised-button>pay a bill<em class="material-icons">arrow_forward</em></button>
      </div>
    </div>
  </div>

  <div *ngIf="userData?.is_onboarded?.setu && type === 'full'" class="payBillPitchWrap returnUser">
    <div class="content" (click)="payBill()">
      <div class="rings">
        <div class="billPayPhone"></div>
        <div class="billPayElec"></div>
        <div class="billPayWater"></div>
        <div class="billPay"></div>
      </div>
      <div *ngIf="isLoading" class="loader"><div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div></div>
      <div *ngIf="!isLoading" class="desc">
        <div class="textWrap">
          <div class="subTitle">Your last bill payment made a difference.</div>
          <div class="title">Pay Another Bill on Ketto</div>
        </div>
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M3.33341 9.16681H10.7801L7.52675 12.4201C7.26675 12.6801 7.26675 13.1068 7.52675 13.3668C7.78675 13.6268 8.20675 13.6268 8.46675 13.3668L12.8601 8.97348C13.1201 8.71348 13.1201 8.29348 12.8601 8.03348L8.47341 3.63348C8.21341 3.37348 7.79341 3.37348 7.53341 3.63348C7.27341 3.89348 7.27341 4.31348 7.53341 4.57348L10.7801 7.83348H3.33341C2.96675 7.83348 2.66675 8.13348 2.66675 8.50014C2.66675 8.86681 2.96675 9.16681 3.33341 9.16681Z" fill="white"/>
        </svg>
      </div>
    </div>
  </div>

  <div *ngIf="type === 'short'" class="payBillPitchWrap short">
    <div class="content" (click)="payBill()">
      <div class="rings">
        <div class="billPayPhone"></div>
        <div class="billPayElec"></div>
        <div class="billPayWater"></div>
        <div class="billPay"></div>
      </div>
      <div *ngIf="isLoading" class="loader"><div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div></div>
      <div *ngIf="!isLoading" class="desc">
        <div class="textWrap">
          <div class="title">You Pay a Bill, Ketto Contributes <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.5 6.50035H8.085L5.645 8.94035C5.45 9.13535 5.45 9.45535 5.645 9.65035C5.84 9.84535 6.155 9.84535 6.35 9.65035L9.645 6.35535C9.84 6.16035 9.84 5.84535 9.645 5.65035L6.355 2.35035C6.16 2.15535 5.845 2.15535 5.65 2.35035C5.455 2.54535 5.455 2.86035 5.65 3.05535L8.085 5.50035H2.5C2.225 5.50035 2 5.72535 2 6.00035C2 6.27535 2.225 6.50035 2.5 6.50035Z" fill="white"/></svg></div>
          <div class="subTitle">Every bill you pay triggers a contribution to someone in need - at no extra cost.</div>
        </div>
      </div>
    </div>
  </div>

</div>

<app-signin-signup
  title="Verify your mobile number to continue"
  [popupView]="true"
  [numberOnly]="true"
  [showPopup]="loginPopupState"
  [noRedirectAfterLogin]="true"
  [hideStartFund]="true"
  [mobileNumber]="userData?.phone_1 || ''"
  [verifyOnly]="true"
  (onClose)="signinClosed($event)"
/>

<!-- <ng-template #setuScreen>
  <iframe [src]="bbpsUrl | safeUrl" width="100%" height="400%"></iframe>
</ng-template> -->



<ng-template #billPayScreen>
  <div *ngIf="screenStep !== 3" class="billPaySreen step-{{screenStep}}">
    <div class="backBtn"><button (click)="goBack()" mat-ripple><em class="material-icons">chevron_left</em></button></div>
    <div class="gifImageWrap">
      <img [hidden]="!isGifCompleted" class="box closed" src="/assets/images/bill-pay/boxClosed.png" alt="box">
      <img [hidden]="!isGifCompleted || screenStep===1" class="box opened" src="/assets/images/bill-pay/boxOpened.png" alt="box">
      <img *ngIf="screenStep===1" [hidden]="isGifCompleted" class="box" src="/assets/images/bill-pay/box.gif" alt="box" (load)="onGifLoad()">
      <img *ngIf="screenStep===2" [hidden]="isGifCompleted" class="box" src="/assets/images/bill-pay/box1.gif" alt="box" (load)="onGifLoad()">
    </div>
    <!-- <div *ngIf="screenStep===1" class="animateImageWrap">
      <img class="box" src="/assets/images/bill-pay/box.png" alt="box">
      <img class="list" src="/assets/images/bill-pay/list.png" alt="list">
      <img class="options" src="/assets/images/bill-pay/bill-options-1.png" alt="options">
    </div>
    <div *ngIf="screenStep===2" class="animateImageWrap">
      <img class="box" src="/assets/images/bill-pay/box.png" alt="box">
      <img class="hearts" src="/assets/images/bill-pay/hearts.png" alt="hearts">
      <img class="options1" src="/assets/images/bill-pay/options1.png" alt="options">
    </div> -->
    <div class="content">
      <div class="desc">
        <div class="title" [innerHTML]="text.title"></div>
        <div class="subTitle" [innerHTML]="text.subTitle"></div>
        <div *ngIf="screenStep===1" class="actBtn">
          <button (click)="nextStep()" mat-ripple><em class="material-icons">arrow_forward</em></button>
        </div>
        <div *ngIf="screenStep===2" class="actBtn">
          <button *ngIf="!isLoading" (click)="nextStep()" mat-ripple>Pay a bill<em class="material-icons">arrow_forward</em></button>
          <button *ngIf="isLoading"><div class="loader"><div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div></div></button>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="screenStep===3" class="billPayTyp">
    <div *ngIf="isLoading" class="body-loader"></div>
    <div *ngIf="!isLoading" class="closeBtn"><button (click)="close()" mat-ripple><em class="material-icons">close</em></button></div>
    <div *ngIf="!isLoading" class="mainContent">
      <div class="birdImg">
        <img src="/assets/images/birds-fly.svg" alt="birds">
      </div>
      <div class="tickAnim" [ngClass]="{'failed': !isPaymentSuccess}">
        <div class="circle">
          <em class="material-icons">{{isPaymentSuccess?'check':'close'}}</em>
        </div>
      </div>
      <div class="desc">
        <div *ngIf="paidAmount" class="amt" [innerHTML]="(currency|currencyIcon)+paidAmount"></div>
        <div class="title" [innerHTML]="typText?.title"></div>
        <div class="subTitle" [innerHTML]="typText?.subTitle"></div>
        <div *ngIf="isPaymentSuccess" class="actBtn"><button (click)="goToDonation()" mat-ripple>Go to my donations <em class="material-icons">arrow_forward</em></button></div>
      </div>
    </div>
    <div class="bottomImg">
      <img *ngFor="let item of [1,2,3,4]" class="hand{{item}}" src="/assets/images/hand-{{item}}.png" alt="hand{{item}}">
    </div>
  </div>
</ng-template>